import { useState } from "react";
import { Navigate } from "react-router-dom";

// The /signup/* steps are for signed-out visitors. A signed-in user who
// opens one goes home instead ("/" sends each role to its home). The check
// runs once, when the step opens: the birthday step (athletes) and the
// name step (every other type) start the session themselves before they
// move on to onboarding or the home, and a guard that re-checked on every
// render would race that move.
const SignedOutOnly = ({ children }) => {
  const [signedIn] = useState(() => !!localStorage.getItem("token"));
  return signedIn ? <Navigate to="/" replace /> : children;
};

export default SignedOutOnly;
